<template>
  <div class="modal fade" ref="custom-modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered" :class="'modal-' + size" role="document">
      <div class="modal-content" tabindex="-1">
        <header class="modal-header">
          <h5 class="modal-title">
            <div class="d-flex align-items-center">
              <i v-if="texts.icon" class="cirx-custom-primary-color mr-4" :class="texts.icon" :style="cssVars" />
              <span class="d-flex align-items-center">{{ texts.title }}</span>
            </div>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onCloseByUser">
            <span aria-hidden="true">&times;</span>
          </button>
        </header>

        <div class="modal-body">
          <!-- Exposed slot : if not used by parent, texts.content will be displayed -->

          <slot name="formatted-content">
            {{ texts.content }}
          </slot>
        </div>

        <div v-if="!hideFooter" class="modal-footer">
          <div :style="cssVars" class="w-100">
            <button
              v-if="withCancelButton"
              type="button"
              class="btn btn-sm"
              :class="withActionButton ? 'btn-secondary' : 'btn-primary cirx-custom-primary-color-btn float-right'"
              @click="onCancel"
            >
              {{ texts.cancelLabel }}
            </button>
            <button
              v-if="withActionButton"
              type="button"
              :disabled="isLoading"
              class="btn btn-primary btn-sm cirx-custom-primary-color-btn float-right cirx-modal-button"
              @click="onConfirm"
            >
              <span v-if="isLoading" class="spinner-border spinner-border-sm"></span>
              <span v-else>{{ texts.confirmLabel }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customCssVarsMixin } from "@/view/mixins/customCssVarsMixin";
import jQuery from "jquery";

// Please see relevant doc : https://recommerce.atlassian.net/wiki/spaces/C/pages/3524460570/Gestion+des+modales

export default {
  name: "CustomModal",

  mixins: [customCssVarsMixin],

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },

    withActionButton: {
      type: Boolean,
      required: false,
      default: false,
    },

    withCancelButton: {
      type: Boolean,
      required: false,
      default: true,
    },

    hideFooter: {
      type: Boolean,
      required: false,
      default: false,
    },

    texts: {
      type: Object,
      required: true,
    },

    size: {
      type: String,
      required: false,
      default: "md",
    },

    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },

  emits: ["shown", "cancel", "confirm", "update:modelValue", "closedByUser"],

  mounted() {
    // to update model when modal is closed by clicking on backdrop or on close button
    jQuery("body").on("hidden.bs.modal", this.$refs["custom-modal"], () => this.$emit("update:modelValue", false));
  },

  beforeUnmount() {
    jQuery(this.$refs["custom-modal"]).modal("hide");
  },

  watch: {
    modelValue: function (show) {
      jQuery(this.$refs["custom-modal"]).modal(show ? "show" : "hide");
    },
  },

  methods: {
    onCancel() {
      this.$emit("update:modelValue", false);
      this.$emit("cancel");
    },

    onConfirm() {
      this.$emit("update:modelValue", false);
      this.$emit("confirm");
    },

    onCloseByUser() {
      this.$emit("update:modelValue", false);
      this.$emit("closedByUser");
    },
  },
};
</script>
